import { render, staticRenderFns } from "./RentalFeeList.vue?vue&type=template&id=12dd6d15&scoped=true&"
import script from "./RentalFeeList.vue?vue&type=script&lang=js&"
export * from "./RentalFeeList.vue?vue&type=script&lang=js&"
import style0 from "./RentalFeeList.vue?vue&type=style&index=0&id=12dd6d15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dd6d15",
  null
  
)

component.options.__file = "RentalFeeList.vue"
export default component.exports